import { render, staticRenderFns } from "./ClientStatusRiskCard.vue?vue&type=template&id=3c681538&scoped=true&"
import script from "./ClientStatusRiskCard.vue?vue&type=script&lang=js&"
export * from "./ClientStatusRiskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c681538",
  null
  
)

export default component.exports